import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import leave from "../../assets/img/leave.svg"
import trash from "../../assets/img/trash.svg"
import mail from "../../assets/img/pop/mail.svg"
import { checkEmailToken, editUserEmail, removeUserAccount } from "../../services/apiProfile";
import { useNavigate } from "react-router-dom";
import otpbox from "../../commonComponents/otpbox";
import Cookies from 'js-cookie';
import OTPInput from "../../commonComponents/otpbox";
import ResponsePopup from "../../commonComponents/responseSucessPopup";
import Validation from "../../commonComponents/Validation";
import { ApiHelper } from "../../helpers/ApiHelper";
import { API } from "../../services/api";
const EditEmail = ({ isEditEmail, handleClose, onSuccess }) => {
    const Group = require("../../assets/img/Featured icon.jpg");
    const userData = JSON.parse(localStorage.getItem('userData'));
    const [email, setEmail] = useState('');
    const [messg, setMessg] = useState('');
    const [isEmailValid, setIsEmailValid] = useState(false);
    const [otp, setOtp] = useState('');
    const [error, setError] = useState(false);
    const [isSucess, SetSucess] = useState(false);
    const [isStatus, SetStatus] = useState(false);
    const [ResponseMessage, SetResponseMessage] = useState("");
    const [emailError, setEmailError] = useState(false);
    const [codeError, setCodeError] = useState(false);

    const navigate = useNavigate()
    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);


        // Basic email validation
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setIsEmailValid(emailPattern.test(value));
        setEmailError(false)
       
        
    };
    
    const handleOtpChange = (otpValue) => {
        setOtp(otpValue);
    };
    const handleGenerate = async () => {
       
        const formData = {
            userid: userData._id,
            email: email,
        }
        let editMail = await editUserEmail(formData);
        if (editMail.status) {
            setMessg(editMail.message);
            SetStatus(editMail.status)
        }
        else{
            setMessg(editMail.message);
            SetStatus(editMail.status)
        }
       

    }
    const handleSubmit = async () => {
        if (otp !== "") {
            setError(false)
            const formData = {
                userid: userData._id,
                resettoken: otp
            }
            let resetEmail = await checkEmailToken(formData);
            if (resetEmail?.status === true) {
                handleClose();
                onSuccess("Please update the edited Email !",resetEmail?.status,email);
            }
            else{
                setCodeError(true);
            }
        }
        else {
            setError(true)
        }

    }
    return (

        <div >
            <Modal show={isEditEmail} onHide={handleClose}
                dialogClassName="small-custom-modal modal-dialog-centered">
                <Modal.Header closeButton>
                    <div className="popupheader">
                        <div className="mod-bor-icon" >
                            <img src={mail} className="mod-icon"></img>
                        </div>
                        <div className="header">
                            <div className="signuup">Edit Email</div>

                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body>

                    <div className="edit-field-group mb-5">
                        <div className="form-group email-verification">
                            <input type="text" placeholder="Enter New Email" className="form-control"
                                value={email}
                                onChange={handleEmailChange}></input>
                                
                            <button disabled={!isEmailValid} className={isEmailValid ? 'verify-btn active' : 'verify-btn'}
                                onClick={() => handleGenerate()}>Generate</button>
                        </div>
                        {email !== "" && emailError ? (
                                <Validation message={'Email already exist'} />
                            ) : null}
                        {messg !== "" && <p className="paragraph-dh">{isStatus ? <i class="bi bi-check-circle-fill mr-2" style={{ color: "green" }}></i> :
                        <i class="bi bi-x-circle-fill" style={{ color: "red" }}></i>}&nbsp;&nbsp;{messg}</p>}
                        <p className="paragraph-dh" >Check your new email for the code and enter it below to continue.</p>
                    </div>


                    {/* otp start  */}

                    <div className="edit-field-group mb-5">
                        <div className="form-group">
                            <h4 className="text-center" >Enter Code</h4>
                            <input type="text" placeholder="Enter your code" className="form-control"
                                value={otp}
                                onChange={(e) => {setOtp(e.target.value); setCodeError(false)}} />
                            {otp === "" && error ? (
                                <Validation message={'Please enter the generated code'} />
                            ) : null}
                            {otp !== "" && codeError ? (
                                <Validation message={'Code is incorrect. Please verify again.'} />
                            ) : null}
                            
                        </div>
                    </div>

                    {/* otp end */}

                </Modal.Body>
                <Modal.Footer className="modal-center" >
                    
                    <button className="next-btn pop-primary btn btn-secondary" onClick={() => handleSubmit()} >Submit</button>
                </Modal.Footer>

            </Modal>
            {isSucess && (<ResponsePopup
                isSucess={isSucess}
                CancelPopup={() => {
                    SetSucess(false);
                }}
                message={ResponseMessage}
            />)}
        </div>
    );

};
export default EditEmail;
